import React, { useState, useEffect } from 'react'
import axios from 'axios'
import Details from './Details'
import MerchandiseAdmin from './Merchandise'
import Packages from './Packages'
import Package from './Package'
import Links from './Links'
import Settings from './Settings'
import { Container, Breadcrumb, BreadcrumbSection, BreadcrumbDivider, Button, Menu, MenuItem, Icon, Message } from 'semantic-ui-react'

const Game = ({ game, goBack }) => {
    const [activeItem, setActiveItem] = useState('')
    const [showSuccessMessage, setShowSuccessMessage] = useState(false)
    const [packageEditingIndex, setPackageEditingIndex] = useState(0)
    const [isSaving, setIsSaving] = useState(false)
    const [detailsDict, setDetailsDict] = useState({})
    const [merchandiseDict, setMerchandiseDict] = useState({})
    const [packagesDict, setPackagesDict] = useState({})
    const [linksDict, setLinksDict] = useState({})
    const [settingsDict, setSettingsDict] = useState({})

    useEffect(() => {
        setDetailsDict(getDictFromGame('details', game))
        setMerchandiseDict(getDictFromGame('merchandise', game))
        setPackagesDict(getDictFromGame('packages', game))
        setLinksDict(getDictFromGame('links', game))
        setSettingsDict(getDictFromGame('settings', game))
        setActiveItem('details')
    }, [game])

    const resetDicts = () => {
        setDetailsDict({})
        setMerchandiseDict({})
        setPackagesDict({})
        setLinksDict({})
        setSettingsDict({})
    }

    const renderContent = () => {
        switch (activeItem) {
            case 'details':
                return <Details savedDict={detailsDict} onStateChange={handleDetailsStateChange}/>
            case 'merchandise':
                if (game.hasPackages) return <h3 style={{ marginTop: 30, color: 'white' }}>Merchandise not applicable, use Packages instead.</h3> 
                return <MerchandiseAdmin game={game.supplierName} savedDict={merchandiseDict} onStateChange={handleMerchandiseStateChange}/>
            case 'packages':
                return <Packages savedDict={packagesDict} packageClicked={handlePackageClicked} hasPackages={game.hasPackages}/>
            case 'package':
                return <Package game={game.supplierName} savedDict={packagesDict.packages[packageEditingIndex]} onStateChange={handlePackageStateChange}/>
            case 'links':
                return <Links savedDict={linksDict} onStateChange={handleLinksStateChange}/>
            case 'settings':
                return <Settings settings={settingsDict} onStateChange={handleSettingsStateChange} gameDeleted={handleDeleteGame}/>
            default:
                return
        }
    }

    const handleMenuItemClicked = (e) => {
        switch (e.target.innerText) {
            case 'Details':
                setActiveItem('details')
                break
            case 'Merchandise':
                setActiveItem('merchandise')
                break
            case 'Packages':
                setActiveItem('packages')
                break
            case 'Links':
                setActiveItem('links')
                break
            case 'Settings':
                setActiveItem('settings')
                break
            default:
                break
        }
    }

    const handleDetailsStateChange = (state) => setDetailsDict(state)
    const handleMerchandiseStateChange = (state) => setMerchandiseDict(state)
    const handlePackageStateChange = (pkg) => {
        const packages = [...packagesDict.packages]
        packages[packageEditingIndex] = pkg
        setPackagesDict({ ...packagesDict, packages })
        setShowSuccessMessage(false)
    }
    const handleLinksStateChange = (state) => setLinksDict(state)
    const handleSettingsStateChange = (state) => setSettingsDict(state)
    const handlePackageClicked = (i) => {
        setPackageEditingIndex(i)
        setActiveItem('package')
    }
    const handleSaveClicked = async () => {
        setIsSaving(true)
        const dict = getCombinedDict()
        await axios.put('/api/game/' + game._id, dict).then(_ => {
            setShowSuccessMessage(true)
            setIsSaving(false)
        }).catch(err => {
            console.log(`edit game failed with error: ${err}`)
            alert(`Failure editing game, please try again. Error: ${err}`)
            setIsSaving(false)
        })
    }
    const handleBackClicked = () => {
        if (activeItem === 'package') {
            setActiveItem('packages')
        } else {
            resetDicts()
            goBack()
        }
    }
    const handleDeleteGame = () => {
        resetDicts()
        goBack()
    }
    const getCombinedDict = () => {
        return { ...detailsDict, ...merchandiseDict, ...packagesDict, ...linksDict, ...settingsDict }
    }

    return (
        <Container inverted style={{ background: '#1b1c1d', minHeight: '100vh', padding: '20px' }}>
            <Breadcrumb inverted style={{ marginBottom: 10 }} size='large'>
                <BreadcrumbSection link onClick={handleBackClicked}>Games</BreadcrumbSection>
                <BreadcrumbDivider color='teal' icon='right chevron' />
                <BreadcrumbSection active>{game.name}</BreadcrumbSection>
            </Breadcrumb>
            <Menu inverted tabular style={{ borderBottom: '1px solid #666'}}>
                <MenuItem name='Details' active={activeItem === 'details'} onClick={handleMenuItemClicked}/>
                <MenuItem name='Merchandise' active={activeItem === 'merchandise'} onClick={handleMenuItemClicked}/>
                <MenuItem name='Packages' active={activeItem === 'packages' || activeItem === 'package'} onClick={handleMenuItemClicked}/>
                <MenuItem name='Links' active={activeItem === 'links'} onClick={handleMenuItemClicked}/>
                <MenuItem name='Settings' active={activeItem === 'settings'} onClick={handleMenuItemClicked}/>
            </Menu>
            {renderContent()}
            <br/><br/><br/><br/><br/><br/><br/><br/><br/>
            <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, background: '#2a2b2c', borderTop: '2px solid #444', padding: '10px', zIndex: 100 }}>
                <Container inverted>
                    {showSuccessMessage ? <Message inverted style={{ marginTop: 20 }} success header='Changes saved successfully.'/> : null}
                    <Button inverted style={{ marginTop: 10, marginRight: 15, marginBottom: 15 }} onClick={handleBackClicked}><Icon name="reply" />Back</Button>
                    <Button inverted loading={isSaving} style={{ marginRight: 15 }} color='teal' onClick={handleSaveClicked}><Icon name="save" />Save</Button>
                </Container>
            </div>
        </Container>
    )
}

const getDictFromGame = (str, game) => {
    switch (str) {
        case 'details':
            const { name, tagline, description, gameImage, aboutThisGame, faq, platforms } = game
            return { name, tagline, description, gameImage, aboutThisGame, faq, platforms }
        case 'merchandise':
            return { gameItems: game.gameItems }
        case 'packages':
            return { packages: game.packages }
        case 'links':
            const { newMetaUpdateLinks, generalGuideLinks, howToPlayLinks, esportsEventLinks, memesFunnyLinks, officialWebsiteLink, fandomLink, redditLink } = game
            return { newMetaUpdateLinks, generalGuideLinks, howToPlayLinks, esportsEventLinks, memesFunnyLinks, officialWebsiteLink, fandomLink, redditLink }
        case 'settings':
            const { _id, priority, supplier, consumerMarkup, supplierName, requiresServerID, requiresCharacterName, instructionalImage, hasPackages, redemptionCodes, isHidden, supplierNotes } = game
            return { id: _id, priority, supplier, consumerMarkup, supplierName, requiresServerID, requiresCharacterName, instructionalImage, hasPackages, redemptionCodes, isHidden, supplierNotes }
        default:
            return {}
    }
}

export default Game